var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinkedin = function SvgLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.7 21H.348V6.98H4.7V21ZM2.522 5.067C1.13 5.067 0 3.914 0 2.522a2.521 2.521 0 0 1 5.043 0c0 1.392-1.13 2.545-2.522 2.545ZM20.995 21h-4.344v-6.825c0-1.627-.033-3.713-2.264-3.713-2.263 0-2.61 1.768-2.61 3.596V21h-4.35V6.98h4.176v1.912h.061c.582-1.101 2.002-2.264 4.12-2.264C20.19 6.628 21 9.53 21 13.298V21h-.005Z",
    fill: "#333"
  })));
};
export default SvgLinkedin;